import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirection1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="direction-1, route"><path d="M12 16.25V20.25M12 16.25H5L2 12L5 7.75H12V16.25ZM12 3.75H19L22 8L19 12.25H12V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDirection1;
